// Validation utility functions
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

export const validatePhoneNumber = (phone: string): boolean => {
  // Remove spaces and common phone number characters
  const cleaned = phone.replace(/[\s\-\(\)]/g, '');
  // Check if it's a valid phone number (at least 7 digits, max 15)
  const phoneRegex = /^[0-9]{7,15}$/;
  return phoneRegex.test(cleaned);
};

